<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <h3>Uploaded Log Files</h3>
        @if (userType == "employee") {
        <p>Optional Search Criteria:</p>
        <div class="field-container">
            <app-uploaded-by-types-component (uploadedByTypeEvent)="receiveUploadedByType($event)" />
            <app-employee-names-component (messageEvent)="receiveMessage($event)" />
            <app-dealer-names-component (messageEvent)="receiveMessage($event)" />
            <app-customer-names-component (messageEvent)="receiveMessage($event)" />
        </div>
        <section style="padding-top: 1vw; padding-bottom: 1vw;">
            <button style="margin-right: 1vw;" mat-flat-button (click)="listLogFiles()">Search</button>
            <button style="margin-right: 1vw;" mat-flat-button (click)="resetSearch()">Reset Search</button>
        </section>
        }

        <p class="text-aerostar-orange">{{message}}</p>

        @if (logFileCount > 0) {
        <div>
            <mat-accordion>
                <section class="mat-elevation-z2 mat-header-row">
                    <span class="mat-header-cell mat-cell-padding">File Name</span>
                    @if (["employee", "dealer", "dealer-rep"].includes(userType)) {
                    <span class="mat-header-cell mat-cell-padding">Uploaded By</span>
                    }
                    <span class="mat-header-cell mat-cell-padding right-align-column">Size (KB)</span>
                    <span class="mat-header-cell mat-cell-padding">Uploaded</span>
                    <span class="mat-header-cell mat-cell-padding">Expires</span>
                    @if (userHasRole("log-downloader") || userHasRole("log-delete")) {
                    <span class="mat-header-cell">Actions</span>
                    }
                </section>
                <mat-expansion-panel hideToggle *ngFor="let logFile of logFiles">
                    <mat-expansion-panel-header class="mat-row">
                        <span class="mat-cell mat-cell-padding">{{logFile.file_name}}</span>
                        @if (["employee", "dealer", "dealer-rep"].includes(userType)) {
                        <span class="mat-cell mat-cell-padding">
                            @if(logFile.uploaded_by_type == "employee") {
                            Employee: {{logFile.uploaded_by_name}}
                            } @else if(logFile.uploaded_by_type == "dealer") {
                            Dealer Contact: {{logFile.uploaded_by_name}}
                            } @else if(logFile.uploaded_by_type == "dealer-rep") {
                            Dealer Rep: {{logFile.uploaded_by_name}}
                            } @else {
                            Customer: {{logFile.uploaded_by_name}}
                            }
                            @if(userType === "employee"
                            && ["dealer", "dealer-rep"].includes(logFile.uploaded_by_type)) {
                            of {{logFile.associated_dealer_name}}
                            }
                        </span>
                        }
                        <span class="mat-cell mat-cell-padding right-align-column">{{logFile.sizeInKb | number}}</span>
                        <span class="mat-cell mat-cell-padding">{{logFile.updated_timestamp | date:'medium' :
                            'Local'}}</span>
                        <span class="mat-cell mat-cell-padding">{{logFile.expires_date | date:'MMM dd, yyyy' :
                            'Local'}}</span>
                        @if (userHasRole("log-downloader") || userHasRole("log-delete")) {
                        <span class="mat-cell">
                            <ng-container matColumnDef="more-vert">
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="View and Update Actions"
                                    (click)=$event.stopPropagation()>
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    @if (userHasRole("log-downloader")) {
                                    <button mat-menu-item (click)="downloadFile(logFile.name, logFile.file_name)">
                                        <span>Download</span>
                                    </button>
                                    }
                                    @if (userHasRole("log-admin")) {
                                    <button mat-menu-item (click)="deleteFile(logFile.name)">
                                        <span>Delete</span>
                                    </button>
                                    }
                                </mat-menu>
                            </ng-container>
                        </span>
                        }
                    </mat-expansion-panel-header>
                    <div>
                        <pre>Nothing here, remove expansion panel.</pre>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <mat-paginator #paginator (page)="handlePageEvent($event)" [length]="logFileCount" [pageSize]="pageSize"
            [disabled]="false" [showFirstLastButtons]="false" [pageSizeOptions]="[5, 10, 25]" [hidePageSize]="false"
            [pageIndex]="pageIndex" aria-label="Select page">
        </mat-paginator>
        }
        @if (logFileCount == 0) {
        <p>No log files found</p>
        }
    </section>
</section>